// extracted by mini-css-extract-plugin
module.exports = {"list__item":"lists-module--list__item--1tegg","icon":"lists-module--icon--1mRDP","container":"lists-module--container--1jUjg","hoverLink":"lists-module--hoverLink--mKjSW"};